import Swiper, {Autoplay, Navigation} from "swiper";

export default (el) => {
  const swiperEl = el.querySelector('.js-sliding')

  new Swiper(swiperEl, {
    modules: [Navigation, Autoplay],
    spaceBetween: 10,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })
}
